import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-square-code w-4 h-4 mr-1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10 9.5 8 12l2 2.5" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m14 9.5 2 2.5-2 2.5" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "18",
  x: "3",
  y: "3",
  rx: "2"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }